module.exports = __webpack_public_path__ + "static/media/IMG_0332.3f0458aa.JPG";